<template>
  <footer id="footer" class="bg-light footer-light"
    :style="'background-color: ' + siteConfiguration.footer_background_color + '!important'">
    <div class="container container-1000">
      <div class="row">
        <div class="col-lg-3 col-sm-6" v-for="(link, index) in siteConfiguration.footer_links"
          :key="index">
          <div class="footer-links">
            <a :href="link.url">
              {{ link.name }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'LayoutCustomFooter',
  props: {
    siteConfiguration: {
      type: Object,
      required: true
    }
  }
}
</script>
